export {TextArea} from './TextArea';
export type {TextAreaProps, TextAreaPin, TextAreaSize, TextAreaView} from './TextArea';
